import { Link } from "react-router";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/shared/components/ui/card";
import { Badge } from "@/shared/components/ui/badge";
import { formatCreatedAgo } from "@/shared/lib/format";
import type { UiReportItem } from "@/features/reports/queries";
import { StatusPill } from "@/shared/components/status-pill";
import { cn } from "@/shared/lib/utils";

export function ReportCard({ item }: { item: UiReportItem }) {
  return (
    <Link to={`/reports/${item.id}`} className="group">
      <Card
        className={cn(
          "transition-shadow",
          item.isExample
            ? "border-muted bg-muted/30 opacity-80"
            : "hover:shadow-md",
        )}
      >
        <CardHeader className="flex flex-row items-start justify-between space-y-0">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <CardTitle className="text-base">{item.name}</CardTitle>
              {item.isExample && (
                <Badge variant="secondary" className="text-xs">
                  Example
                </Badge>
              )}
              {item.isExample && (
                <Badge variant="outline" className="text-xs">
                  Read-only
                </Badge>
              )}
            </div>
            <CardDescription className="truncate">
              Type: <span className="capitalize">{item.type}</span>
              {item.context && (
                <>
                  {" - "}
                  {item.context}
                </>
              )}
            </CardDescription>
          </div>
          <StatusPill status={item.status} />
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            {formatCreatedAgo(item.createdAt)}
          </div>
        </CardContent>
        <CardFooter className="text-xs text-primary">
          <span className="group-hover:underline">
            {item.isExample ? "Open read-only report ->" : "Open report ->"}
          </span>
        </CardFooter>
      </Card>
    </Link>
  );
}
